import React from "react";
import CustomTabs from "../../components/CustomComponents/CustomTabs/CustomTabs";
import CustomTab from "../../components/CustomComponents/CustomTab/CustomTab";
import CustomBox from "../../components/CustomComponents/CustomBox/CustomBox";
import PropTypes from "prop-types";
import { useStyles } from "../../assets/jss/Events";
import SpeedingTab from "../../components/SpeedingTab/SpeedingTab";
import BrakingTab from "../../components/BrakingTab/BrakingTab";
import CorneringTab from "../../components/CorneringTab/CorneringTab";
import DistractionTab from "../../components/DistractionTab/DistractionTab";
import DateTime from "../../components/DateTime/DateTime";
import CustomTypography from "../../components/CustomComponents/CustomTypography/CustomTypography";
import CustomGrid from "../../components/CustomComponents/CustomGrid/CustomGrid";
import { useHistory } from "react-router-dom";
import { Helmet } from "react-helmet";
import { getUserData, checkAPICallDate } from "../../services/LocalStorageService";
import { APICache, EntityAccess } from "../../config/app-globals.enum";
import { getDistractionEnabledForView, getVisibleEventCount } from "../../services/LocalStorageService";
import { useTranslation } from "react-i18next";
import AccelerationTab from "../../components/AccelerationTab/AccelerationTab";

export default function Events(props) {
    const { t } = useTranslation();
    const classes = useStyles();
    const [value, setValue] = React.useState("#tabSPEEDING");
    const [currentDate, setAPICallDate] = React.useState(new Date());
    const [currentHash, setCurrentHash] = React.useState(null);
    const [googleAnalyticsId] = React.useState(process.env.REACT_APP_GOOGLE_TAG_ID);
    const userData = getUserData();
    const [isDistractionEnabledForView] = React.useState(getDistractionEnabledForView);
    const [visibleEventCount] = React.useState(getVisibleEventCount);

    const history = useHistory();

    React.useEffect(() => {
        setCurrentHash(history.location.hash);
        setValue(history.location.hash);
        // setValue(
        //     history.location.hash === "#tabSPEEDING"
        //         ? 0
        //         : history.location.hash === "#tabBRAKING"
        //             ? 1
        //             : history.location.hash === "#tabCORNERING"
        //                 ? 2
        //                 : history.location.hash === "#tabACCELERATION"
        //                     ? 2
        //                     : history.location.hash === "#tabDRIVER_DISTRACTION"
        //                         ? 4
        //                         : 0
        // );

    }, []);

    React.useEffect(() => {
        if (history.location.hash === "#tabSPEEDING") {
            setAPICallDate(checkAPICallDate(APICache.SPEED_EVENT));
        } else if (history.location.hash === "#tabBRAKING") {
            setAPICallDate(checkAPICallDate(APICache.BRAKING_EVENT));
        } else if (history.location.hash === "#tabCORNERING") {
            setAPICallDate(checkAPICallDate(APICache.CORNRING_EVENT));
        } else if (history.location.hash === "#tabACCELERATION") {
            setAPICallDate(checkAPICallDate(APICache.ACCELERATION_EVENT));
        } else {
            setAPICallDate(checkAPICallDate(APICache.MOBILE_DISTRACTION_EVENT));
        }
    }, []);

    function a11yProps(index) {
        return {
            id: `simple-tab-${index}`,
            "aria-controls": `simple-tabpanel-${index}`,
        };
    }

    function TabPanel(props) {
        const { children, value, index, id, hashId, ...other } = props;
        return (
            <div
                role="tabpanel"
                hidden={`#${id}` !== hashId && `#${id}` !== "#tabSPEEDING"}
                id={`simple-tabpanel-${index}`}
                aria-labelledby={`simple-tab-${index}`}
                {...other}
            >
                {(`#${id}` === hashId || hashId === "") && (
                    <CustomBox m={3}>{children}</CustomBox>
                )}
            </div>
        );
    }
    TabPanel.propTypes = {
        id: PropTypes.any,
        hashId: PropTypes.any,
        children: PropTypes.node,
        index: PropTypes.any.isRequired,
        value: PropTypes.any.isRequired,
        className: PropTypes.any,
    };

    return (
        <>
            <CustomGrid
                container
                spacing={0}
                justifyContent="space-between"
                alignItems="center"
            >
                <CustomGrid item>
                    <CustomTabs
                        value={value}
                        aria-label={t("EVENTS_TAB")}
                        indicatorColor="primary"
                        className={classes.tabs}
                    >
                        {visibleEventCount && visibleEventCount.length > 0 ? visibleEventCount.map(tab =>
                            <CustomTab href={`#tab${tab}`} value={`#tab${tab}`} key={tab} label={t(tab)} {...a11yProps(visibleEventCount.indexOf(tab))} />
                        ) : (
                            <>
                                <CustomTab href="#tabSPEEDING" label={t("SPEEDING")} {...a11yProps(0)} />
                                <CustomTab href="#tabBRAKING" label={t("BRAKING")} {...a11yProps(1)} />
                                <CustomTab href="#tabCORNERING" label={t("CORNERING")}{...a11yProps(2)} />
                                {isDistractionEnabledForView && isDistractionEnabledForView === EntityAccess.ALLOWED &&
                                    <CustomTab href="#tabDRIVER_DISTRACTION" label={t("DRIVER_DISTRACTION")}{...a11yProps(3)}
                                    />}
                            </>
                        )}
                    </CustomTabs>
                </CustomGrid>
                <CustomGrid item>
                    <CustomTypography
                        className={classes.headerSubNote}
                        component="p"
                        variant="h6"
                    >
                        {t("LAST_UPDATED_ON")}{" "}
                        <DateTime inputDate={currentDate} returnFormat="ddd" />,{" "}
                        <DateTime inputDate={currentDate} returnFormat="DD MMM YYYY" /> |{" "}
                        <DateTime inputDate={currentDate} returnFormat="hh:mm a" />
                    </CustomTypography>
                </CustomGrid>
            </CustomGrid>

            <TabPanel
                id="tabSPEEDING"
                hashId={currentHash}
                className={classes.tabPanel}
                value={value}
                index={0}
            >
                <SpeedingTab {...props} />
            </TabPanel>
            <TabPanel
                id="tabBRAKING"
                hashId={currentHash}
                className={classes.tabPanel}
                value={value}
                index={1}
            >
                <BrakingTab {...props} />
            </TabPanel>
            <TabPanel
                id="tabCORNERING"
                hashId={currentHash}
                className={classes.tabPanel}
                value={value}
                index={2}
            >
                <CorneringTab {...props} />
            </TabPanel>
            <TabPanel
                id="tabACCELERATION"
                hashId={currentHash}
                className={classes.tabPanel}
                value={value}
                index={3}
            >
                <AccelerationTab {...props} />
            </TabPanel>
            <TabPanel
                id="tabDRIVER_DISTRACTION"
                hashId={currentHash}
                className={classes.tabPanel}
                value={value}
                index={4}
            >
                <DistractionTab {...props} />
            </TabPanel>

            <Helmet>
                <script
                    async
                    src={`https://www.googletagmanager.com/gtag/js?id=${googleAnalyticsId}`}
                ></script>
                <script>
                    {`
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', "${googleAnalyticsId}");
        `}
                </script>
            </Helmet>
        </>
    );
}
